
export class FacilityHubActions {
  readonly Facility_Notifications: string = "Notifications";
  readonly Pip_Notifications: string = "PipNotifications";
}
